import * as React from 'react';
import { ProductContext } from '../../../../pages/ProductStencil';
import { useContext, useState } from 'react';
import { useI18N } from "../../../../my-puratos/hoc/withI18N";
import { requestAlternativeMaterial } from '../../../../../api/ECOM/requestAlternativeMaterial.api';

export const Obsolete = () => {
    const { SapDetails, product, activeProductIndex, breadcrumb } = useContext(ProductContext);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const translate = useI18N();
    const { title } = product;
    const materialNumber = SapDetails[0].MaterialNumber;
    const aemURL = window.location.href;

    const handleViewAlternatives = async () => {
        try {
            setButtonDisabled(true);
            const response = await requestAlternativeMaterial(materialNumber, aemURL);
            const alternativesUrl = `${breadcrumb.elements[1].url}${breadcrumb.elements[1].queryParams ? `?${new URLSearchParams(breadcrumb.elements[1].queryParams).toString()}` : ''}`;
            window.location.href = alternativesUrl;
        } catch (error) {
            console.error("Error fetching alternative materials:", error);
        }
    };

    return (
        <div className="pdp__overview--discontinued">
            <h1 className="pdp__overview--title">
                {title}
                <span className="pdp__overview--subtitle">{SapDetails[activeProductIndex].Packaging}</span>
            </h1>
            <p>{translate("There is no price available for this product")}.</p>
            <button className="btn btn-primary" onClick={handleViewAlternatives} disabled={buttonDisabled}>
                {translate("View alternatives")}
            </button>
        </div>
    );
};
